export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20editorial%20flat%20lay%20composition%20featuring%20carefully%20arranged%20fashion%20accessories%20including%20a%20textured%20leather%20bag%20folded%20knit%20sweater%20and%20delicate%20gold%20toned%20jewelry%20pieces%20floating%20on%20a%20warm%20oatmeal%20colored%20background%20with%20gentle%20sage%20green%20botanical%20accents%20soft%20diffused%20natural%20light%20modern%20Scandinavian%20aesthetic%20with%20organic%20shadows%20and%20harmonious%20spacing%20high%20detail%20product%20photography&width=1600&height=900&seq=hero-bg-v2-main&orientation=landscape"
          alt="AllChinaBuy Spreadsheet product collection"
          title="AllChinaBuy Spreadsheet - Best AllChinaBuy Spreadsheet 2026"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/30"></div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 text-center lg:text-left pt-20 md:pt-24">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-background-50/30 bg-background-50/10 backdrop-blur-sm mb-6">
              <span className="w-2 h-2 rounded-full bg-primary-500"></span>
              <span className="text-xs font-medium text-background-50">Updated June 2026</span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-5">
              Best AllChinaBuy<br />
              <span className="text-primary-400">Spreadsheet 2026</span>
            </h1>

            <p className="text-base md:text-lg text-background-200 max-w-lg mx-auto lg:mx-0 leading-relaxed mb-8">
              Discover the latest AllChinaBuy Spreadsheet with trusted sellers, quality products, verified links, and safe buying guides — all in one organized resource.
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 dark:text-foreground-950 font-medium rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer inline-flex items-center justify-center gap-2 text-sm"
              >
                Explore Now
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-sm"></i>
                </span>
              </a>
              <a
                href="#categories"
                className="w-full sm:w-auto px-8 py-3.5 border border-background-50/40 text-background-50 font-medium rounded-full hover:bg-background-50/10 transition-all whitespace-nowrap cursor-pointer text-sm text-center"
              >
                Browse Categories
              </a>
            </div>

            <div className="flex flex-wrap items-center gap-5 justify-center lg:justify-start mt-8">
              {['Verified Sellers', 'Quality Comparisons', 'Updated Links', 'Safe Shopping'].map((item) => (
                <span key={item} className="flex items-center gap-1.5 text-xs text-background-300">
                  <span className="w-4 h-4 flex items-center justify-center text-primary-400">
                    <i className="ri-check-line text-xs"></i>
                  </span>
                  {item}
                </span>
              ))}
            </div>
          </div>

          <div className="flex-1 hidden lg:block"></div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <a
          href="#what-is"
          className="flex flex-col items-center gap-2 text-background-300 hover:text-background-50 transition-colors cursor-pointer"
        >
          <span className="text-xs font-medium">Scroll to explore</span>
          <span className="w-5 h-5 flex items-center justify-center animate-bounce">
            <i className="ri-arrow-down-line"></i>
          </span>
        </a>
      </div>
    </section>
  );
}